import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { assets } from "../Assets/assets";

/**
 * PCM EXPORTS Company Configuration Details
 */
export const PCM_EXPORTS_DETAILS = {
  authorizedBy: "PCM EXPORTS",
  address:
    "Block-A, Bharati Tower, Forestpark, Ekamra Marg, Bhimpur, Bhubaneswar, Khordha, Odisha(India) - 751009",
  gstin: "21AAACP1234A1Z5",
  contactNumber: "+91-9876543210",
  founderSignatureTitle: "Founder & CEO, PCM EXPORTS",
};

/**
 * Format date nicely for display
 */
const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return dateStr;
  }
};

/**
 * Generates HTML string for Client Visit Pass template
 */
export const getVisitPassHTML = (pass) => {
  const {
    passNumber,
    assignmentNumber,
    assignmentDetails,
    validity,
    ofmDetails,
    clientDetails,
    status,
    createdAt,
    passType,
  } = pass || {};

  const fromStr = formatDate(validity?.fromDate);
  const toStr = formatDate(validity?.toDate);
  const issuedOn = formatDate(createdAt);

  const ofmPhoto =
    ofmDetails?.photo ||
    pass?.ofmId?.profilePic ||
    pass?.ofmId?.identityVerification?.aadhaar?.photoUrl ||
    null;

  const isManual = passType === "Manual" || pass?.isManual;
  const stageLabel = isManual
    ? "🟣 MANUAL VISIT PASS"
    : passType === "Sample"
    ? "📦 SAMPLE STAGE ORDER"
    : passType === "Dispute"
    ? "⚠️ DISPUTE RESOLUTION"
    : "🚚 FULL ORDER STAGE";

  const logoSrc = assets?.qqtlogo || assets?.logo || "/assets/qqtlogo.png";
  const authAddress = PCM_EXPORTS_DETAILS.address;
  const authGstin = PCM_EXPORTS_DETAILS.gstin;
  const authContact = PCM_EXPORTS_DETAILS.contactNumber;

  return `
  <div style="width: 794px; min-height: 1122px; padding: 40px; background-color: #ffffff; box-sizing: border-box; font-family: 'Segoe UI', Arial, sans-serif; color: #1e293b; position: relative;">
    
    <!-- Top Decorative Banner -->
    <div style="height: 8px; background: linear-gradient(90deg, #991b1b 0%, #dc2626 50%, #f87171 100%); margin-bottom: 24px; border-radius: 4px;"></div>

    <!-- Header Section -->
    <div style="display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 20px; border-bottom: 2px solid #e2e8f0;">
      <div>
        <img src="${logoSrc}" style="height: 48px; width: auto; object-fit: contain; margin-bottom: 8px; display: block;" alt="QQT Logo" />
        <h1 style="margin: 0; font-size: 26px; font-weight: 800; color: #991b1b; letter-spacing: -0.5px;">PCM EXPORTS</h1>
        <p style="margin: 4px 0 0 0; font-size: 11px; color: #64748b; font-weight: 500;">Official Quality Inspection & Fulfillment Division</p>
        <p style="margin: 6px 0 0 0; font-size: 10px; color: #475569; max-width: 420px; line-height: 1.4;">
          <strong>Regd Office:</strong> ${authAddress}
        </p>
        <p style="margin: 3px 0 0 0; font-size: 10px; color: #475569;">
          <strong>GSTIN:</strong> ${authGstin} | <strong>Contact:</strong> ${authContact}
        </p>
      </div>

      <div style="text-align: right;">
        <div style="display: inline-block; background-color: #eff6ff; border: 1.5px solid #bfdbfe; color: #1e40af; padding: 5px 12px; border-radius: 6px; font-weight: 700; font-size: 12px;">
          TEMPORARY CLIENT VISIT PASS
        </div>
        <div style="margin-top: 4px;">
          <span style="display: inline-block; background-color: ${isManual ? '#f3e8ff' : '#fee2e2'}; border: 1.5px solid ${isManual ? '#d8b4fe' : '#fca5a5'}; color: ${isManual ? '#7e22ce' : '#991b1b'}; padding: 3px 10px; border-radius: 5px; font-weight: 800; font-size: 11px;">
            ${stageLabel}
          </span>
        </div>
        <p style="margin: 8px 0 0 0; font-size: 11px; font-family: monospace; font-weight: 700; color: #0f172a;">
          Pass No: <span style="color: #991b1b;">${passNumber || "CVP-2026-000"}</span>
        </p>
        <p style="margin: 3px 0 0 0; font-size: 10px; color: #64748b;">
          Issued On: ${issuedOn}
        </p>
      </div>
    </div>

    <!-- Validity & Status Header Card -->
    <div style="margin-top: 20px; background: #fff5f5; border: 1px solid #fecaca; border-radius: 8px; padding: 14px 20px; display: flex; justify-content: space-between; align-items: center;">
      <div>
        <span style="font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;">PASS VALIDITY PERIOD</span>
        <div style="font-size: 15px; font-weight: 700; color: #0f172a; margin-top: 2px;">
          ${fromStr} &nbsp;<span style="color: #94a3b8;">TO</span>&nbsp; ${toStr}
        </div>
      </div>

      <div style="text-align: right;">
        <span style="font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px;">PASS STATUS</span>
        <div style="margin-top: 2px;">
          <span style="display: inline-block; padding: 4px 12px; font-size: 11px; font-weight: 800; border-radius: 20px; text-transform: uppercase; ${
            status === "Active"
              ? "background-color: #dcfce7; color: #166534; border: 1px solid #86efac;"
              : status === "Revoked"
              ? "background-color: #fee2e2; color: #991b1b; border: 1px solid #fca5a5;"
              : "background-color: #f1f5f9; color: #475569; border: 1px solid #cbd5e1;"
          }">
            ${status || "Active"}
          </span>
        </div>
      </div>
    </div>

    <!-- Main Grid: OFM Photo & Details -->
    <div style="margin-top: 24px; display: flex; gap: 24px; align-items: flex-start;">
      
      <!-- OFM Photo Box -->
      <div style="width: 140px; text-align: center;">
        <div style="width: 130px; height: 150px; border: 2px dashed #cbd5e1; border-radius: 8px; padding: 4px; background: #ffffff; display: flex; align-items: center; justify-content: center; overflow: hidden; margin: 0 auto;">
          ${
            ofmPhoto
              ? `<img src="${ofmPhoto}" crossorigin="anonymous" alt="OFM" style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px; display: block;" />`
              : `<div style="width: 100%; height: 100%; background: #e2e8f0; display: flex; align-items: center; justify-content: center; border-radius: 4px; color: #64748b; font-size: 12px; font-weight: 600;">PHOTO</div>`
          }
        </div>
        <p style="margin: 8px 0 0 0; font-size: 10px; font-weight: 700; color: #475569; text-transform: uppercase;">AUTHORISED OFM</p>
      </div>

      <!-- OFM Info Grid -->
      <div style="flex: 1; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h3 style="margin: 0 0 12px 0; font-size: 12px; font-weight: 800; color: #991b1b; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #f1f5f9; padding-bottom: 6px;">
          1. OFM Identification
        </h3>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
          <div>
            <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">NAME OF OFM</span>
            <span style="font-size: 13px; font-weight: 700; color: #0f172a;">${ofmDetails?.name || "N/A"}</span>
          </div>

          <div>
            <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">DESIGNATION / ROLE</span>
            <span style="font-size: 12px; font-weight: 600; color: #991b1b;">Order Fulfillment Manager</span>
          </div>

          <div>
            <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">MOBILE NUMBER</span>
            <span style="font-size: 12px; font-weight: 600; color: #0f172a;">${ofmDetails?.phone || "N/A"}</span>
          </div>

          <div>
            <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">AADHAR NUMBER</span>
            <span style="font-size: 12px; font-weight: 600; color: #0f172a;">${ofmDetails?.aadharNumber || "N/A"}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2: Assignment Details -->
    <div style="margin-top: 20px; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
      <h3 style="margin: 0 0 12px 0; font-size: 12px; font-weight: 800; color: #991b1b; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #f1f5f9; padding-bottom: 6px;">
        2. Assignment & Task Information
      </h3>

      <div style="display: grid; grid-template-columns: 1fr 1fr 1.5fr; gap: 12px;">
        <div>
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">ORDER TYPE</span>
          <span style="font-size: 12px; font-weight: 800; color: #991b1b;">${stageLabel}</span>
        </div>

        <div>
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">PASS ISSUED FOR</span>
          <span style="font-size: 13px; font-weight: 700; color: #0f172a; font-family: monospace;">${assignmentNumber || "N/A"}</span>
        </div>

        <div>
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">ASSIGNMENT DETAILS / PURPOSE</span>
          <span style="font-size: 12px; font-weight: 600; color: #334155; line-height: 1.4;">${assignmentDetails || "Client office/warehouse visit task"}</span>
        </div>
      </div>
    </div>

    <!-- Section 3: Client Information (Warehouse / Office) -->
    <div style="margin-top: 20px; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
      <h3 style="margin: 0 0 12px 0; font-size: 12px; font-weight: 800; color: #1e3a8a; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #f1f5f9; padding-bottom: 6px;">
        3. Client Warehouse / Destination Address
      </h3>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
        <div style="grid-column: span 2;">
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">CLIENT NAME (COMPANY)</span>
          <span style="font-size: 14px; font-weight: 700; color: #0f172a;">${clientDetails?.companyName || "N/A"}</span>
        </div>

        <div style="grid-column: span 2;">
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">CLIENT WAREHOUSE / OFFICE ADDRESS</span>
          <span style="font-size: 12px; font-weight: 600; color: #1e293b; line-height: 1.4;">${clientDetails?.address || "N/A"}</span>
        </div>

        <div>
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">CLIENT GSTIN</span>
          <span style="font-size: 12px; font-weight: 600; color: #0f172a;">${clientDetails?.gstin || "N/A"}</span>
        </div>

        <div>
          <span style="font-size: 10px; color: #64748b; font-weight: 600; display: block;">CLIENT CONTACT NUMBER</span>
          <span style="font-size: 12px; font-weight: 600; color: #0f172a;">${clientDetails?.contactNumber || "N/A"}</span>
        </div>
      </div>
    </div>

    <!-- Section 4: Authorization & Terms Footer -->
    <div style="margin-top: 24px; padding: 16px; border: 1px solid #cbd5e1; border-radius: 8px; background: #fafafa; display: flex; justify-content: space-between; align-items: flex-end;">
      
      <div style="max-width: 440px;">
        <span style="font-size: 10px; font-weight: 700; color: #1e3a8a; text-transform: uppercase; display: block; margin-bottom: 4px;">AUTHORIZED BY: PCM EXPORTS</span>
        <p style="font-size: 10px; color: #475569; margin: 0; line-height: 1.4;">
          This pass certifies that the named Order Fulfillment Manager is officially authorized by <strong>PCM EXPORTS</strong> to visit the client warehouse/office premises for specified inspection, sampling, or fulfillment duties.
        </p>
        <p style="font-size: 9px; color: #94a3b8; margin: 6px 0 0 0;">
          * Mandatory: This pass must be presented at the client entry point upon request.
        </p>
      </div>

      <!-- Stamp & Signature Text Box -->
      <div style="text-align: center; width: 190px;">
        <div style="height: 60px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <div style="font-size: 16px; font-weight: 800; color: #1e3a8a; letter-spacing: 0.5px;">
            PCM EXPORTS
          </div>
          <div style="font-size: 9px; font-weight: 600; color: #64748b; margin-top: 2px;">
            Official Authorization
          </div>
        </div>

        <div style="border-top: 1.5px solid #94a3b8; padding-top: 3px; font-size: 10px; font-weight: 700; color: #0f172a; margin-top: 4px;">
          PCM EXPORTS AUTHORISED
        </div>
      </div>
    </div>

    <!-- Bottom Line -->
    <div style="position: absolute; bottom: 20px; left: 40px; right: 40px; font-size: 9px; color: #94a3b8; text-align: center; border-top: 1px solid #f1f5f9; padding-top: 8px;">
      PCM EXPORTS • Temporary Client Visit Authorization System • Generated on ${issuedOn} • Confidential Document
    </div>

  </div>
  `;
};

/**
 * Generates an SVG data URL with OFM identity badge & initials as a reliable vector fallback
 */
export const createOfmAvatarDataUrl = (name) => {
  const initials = (name || "OFM")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "OFM";

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="240" viewBox="0 0 200 240">
    <defs>
      <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style="stop-color:#1e3a8a;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#2563eb;stop-opacity:1" />
      </linearGradient>
    </defs>
    <rect width="200" height="240" rx="8" fill="url(#bgGrad)" />
    <!-- User Icon Silhouette -->
    <circle cx="100" cy="85" r="38" fill="#ffffff" opacity="0.95" />
    <path d="M 35 190 C 35 130, 165 130, 165 190 Z" fill="#ffffff" opacity="0.95" />
    <!-- Initials & Badge -->
    <rect x="20" y="196" width="160" height="30" rx="6" fill="#0f172a" />
    <text x="100" y="216" font-family="Arial, sans-serif" font-size="13" font-weight="bold" fill="#ffffff" text-anchor="middle" letter-spacing="1">OFM • ${initials}</text>
  </svg>`;

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

/**
 * Converts an image URL to base64 data URL for reliable html2canvas rendering
 */
export const convertUrlToBase64 = async (url) => {
  if (!url || typeof url !== "string") return null;
  if (url.startsWith("data:")) return url;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3500);
    const response = await fetch(url, { mode: "cors", signal: controller.signal });
    clearTimeout(timeoutId);
    if (!response.ok) {
      return null;
    }
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("[convertUrlToBase64] Could not convert image to base64:", err);
    return null;
  }
};

/**
 * Generate PDF and initiate download
 */
export const downloadVisitPassPDF = async (pass) => {
  try {
    const rawPhoto =
      pass?.ofmDetails?.photo ||
      pass?.ofmId?.profilePic ||
      pass?.ofmId?.identityVerification?.aadhaar?.photoUrl ||
      null;

    const ofmName =
      pass?.ofmDetails?.name ||
      (pass?.ofmId
        ? `${pass.ofmId.firstName || ""} ${pass.ofmId.lastName || ""}`.trim()
        : "OFM Executive");

    let finalPhoto = null;
    if (rawPhoto) {
      finalPhoto = await convertUrlToBase64(rawPhoto);
    }
    if (!finalPhoto) {
      finalPhoto = createOfmAvatarDataUrl(ofmName);
    }

    const enrichedPass = {
      ...pass,
      ofmDetails: {
        ...pass?.ofmDetails,
        name: ofmName,
        photo: finalPhoto,
      },
    };

    const htmlContent = getVisitPassHTML(enrichedPass);

    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-9999px";
    container.style.left = "-9999px";
    container.style.width = "794px";
    container.style.minHeight = "1122px";
    container.style.background = "#ffffff";

    container.innerHTML = htmlContent;
    document.body.appendChild(container);

    // Wait for all images inside container to finish loading
    const images = container.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    );

    await new Promise((res) => setTimeout(res, 300));

    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      width: 794,
    });

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
    const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm

    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const imgHeightMm = (canvas.height / canvas.width) * pageWidth;

    pdf.addImage(imgData, "JPEG", 0, 0, pageWidth, Math.min(imgHeightMm, pageHeight));

    document.body.removeChild(container);

    const fileName = `Client_Visit_Pass_${(pass?.passNumber || "CVP").replace(/[\/\\?%*:|"<>]/g, "_")}.pdf`;
    pdf.save(fileName);

    return true;
  } catch (error) {
    console.error("[downloadVisitPassPDF] Error generating PDF:", error);
    throw error;
  }
};
